export default class Locale_PropertyMapping { 
	TPProperty: string = "TP property";
	OriginPropertyName: string = "Origin property name";
}